import { Layout as AntdLayout, Card, Row, Tabs } from "antd";
import { useGetIdentity } from "@refinedev/core";
import {
  OtherServiceSubscriptionDetails,
  ServiceSubscription,
  SubscriptionDetails,
} from "components/dashboard";
import React from "react";
import { shadows } from "config/theme";

export const Dashboard: React.FC = () => {
  const { data: identity } = useGetIdentity();

  if (identity?.role === "VesselUser") {
    return (
      <AntdLayout className="layout">
        <Row
          justify="center"
          align="middle"
          style={{ height: "87vh" }}
        />
      </AntdLayout>
    );
  }

  return (
    <Card
      style={{
        borderRadius: 12,
        boxShadow: shadows.md,
        border: "none",
      }}
      styles={{
        body: { padding: 0 },
      }}
    >
      <Tabs
        defaultActiveKey="service"
        size="middle"        
        tabBarStyle={{
          marginBottom: 0,
          padding: "0 24px",
        }}
        items={[
          {
            key: "service",
            label: "Service Subscription",
            children: (
              <div style={{ padding: 24 }}>
                <ServiceSubscription />
              </div>
            ),
          },
          {
            key: "details",
            label: "Subscription Details",
            children: (
              <div style={{ padding: 24 }}>
                <SubscriptionDetails />
              </div>
            ),
          },
          {
            key: "other",
            label: "Other Services",
            children: (
              <div style={{ padding: 24 }}>
                <OtherServiceSubscriptionDetails />
              </div>
            ),
          },
        ]}
      />
    </Card>
  );
};
